var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorking3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 35.929,16.377 30.317,18.891 39.336,11.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 35.929,16.377 41.542,13.863 33.139,21.159  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M44.628,14.63c3.14,0,5.702-2.562,5.702-5.703c0-3.141-2.563-5.703-5.702-5.703c-3.143,0-5.704,2.562-5.704,5.703 C38.924,12.068,41.485,14.63,44.628,14.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 51.333,18.861 55.465,24.225 49.905,11.088  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 51.333,18.861 47.499,14.055 52.038,25.189  "
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M51.943,34.591c-1.467-1.032-2.426-2.739-2.426-4.669c0-3.149,2.553-5.703,5.702-5.703s5.704,2.553,5.704,5.703 c0,1.016-0.267,1.97-0.73,2.796"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 38.663,39.088 33.357,30.962 36.468,41.35  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 51.97,
    y1: 34.609,
    x2: 55.465,
    y2: 24.225
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 52.038,
    y1: 25.189,
    x2: 60.149,
    y2: 32.794
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 49.583,
    y1: 30.791,
    x2: 60.556,
    y2: 27.903
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 51.943,
    y1: 34.591,
    x2: 60.149,
    y2: 32.794
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M60.149,32.794L46.453,45.167c-1.378-0.438-2.072-1.275-1.579-2.806l7.096-7.752"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M46.453,45.167l9.703,0.41c2.242-0.102,4.095-0.545,4.506-3.043l-0.469-9.816"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 51.97,
    y1: 34.609,
    x2: 60.63,
    y2: 41.869
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 51.97,
    y1: 34.609,
    x2: 55.688,
    y2: 45.557
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 44.874,
    y1: 42.362,
    x2: 60.63,
    y2: 41.869
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 39.336,11.061 44.465,12.841 49.905,11.088  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 44.628,
    y1: 3.224,
    x2: 44.348,
    y2: 14.627
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 38.992,
    y1: 8.202,
    x2: 50.346,
    y2: 8.672
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 47.499,14.055 44.465,12.841 41.542,13.863  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.14,
    y: 19.446,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 9.178,
    height: 4.034
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 33.139,21.159 30.317,23.48 33.357,30.962  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 21.14,
    y1: 19.446,
    x2: 30.317,
    y2: 23.48
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 33.139,21.159 38.502,32.541 33.357,30.962  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 38.502,32.541 38.663,39.087 33.357,30.962  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M12.722,41.485h23.384c5.306,0,9.646,4.34,9.646,9.645l0,0c0,5.305-4.34,9.646-9.646,9.646H12.722c-5.304,0-9.646-4.34-9.646-9.646 l0,0C3.076,45.825,7.418,41.485,12.722,41.485z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 14.125,60.776 14.125,41.485 3.076,51.13  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M24.414,56.203c-2.681,0-4.853-2.172-4.853-4.852c0-2.68,2.172-4.852,4.853-4.852c0.017,0,0.034,0,0.052,0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M14.125,56.203c2.673,0,4.852-2.179,4.852-4.852c0-2.673-2.179-4.852-4.852-4.852c-2.672,0-4.852,2.179-4.852,4.852 C9.273,54.023,11.453,56.203,14.125,56.203z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 3.076,
    y1: 51.13,
    x2: 24.414,
    y2: 51.13
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 24.457,56.203 14.125,56.203 14.125,46.499 24.428,46.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 18.972,51.13 14.125,46.499 9.278,51.13 14.125,56.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 14.125,41.485 24.414,43.992 14.125,46.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 14.125,56.203 24.414,56.203 14.125,60.776  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 34.702,60.776 34.702,41.485 45.751,51.13  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M24.414,56.204c2.68,0,4.852-2.172,4.852-4.853c0-2.679-2.172-4.852-4.852-4.852c-0.018,0-0.035,0-0.053,0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M34.702,56.204c2.673,0,4.852-2.179,4.852-4.853c0-2.671-2.179-4.852-4.852-4.852c-2.672,0-4.852,2.18-4.852,4.852 C29.851,54.024,32.03,56.204,34.702,56.204z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 45.751,
    y1: 51.13,
    x2: 24.414,
    y2: 51.13
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 24.37,56.204 34.702,56.204 34.702,46.5 24.4,46.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 29.855,51.13 34.702,46.5 39.549,51.13 34.702,56.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 34.702,41.485 24.414,43.992 34.702,46.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 34.702,56.204 24.414,56.204 34.702,60.776  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 10.091,25.95 17.516,25.95 14.125,41.485 9.683,41.298  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M17.516,25.95l3.976,0.993l-0.352-4.91h-3.422L17.516,25.95L17.516,25.95z M17.879,19.52l3.261-0.073v2.587h-3.422L17.879,19.52z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 10.007,
    y1: 29.112,
    x2: 14.402,
    y2: 41.552
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 21.491,26.943 23.901,30.919 13.378,25.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 33.357,30.962 14.378,41.485 23.901,30.919  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 34.702,41.485 23.901,30.919 9.729,39.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 29.262,51.13 24.414,46.5 19.567,51.13 24.414,56.204  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking3);
export default __webpack_public_path__ + "static/media/working3.7026daf46099683157ceddb1ae5cd0ac.svg";
export { ForwardRef as ReactComponent };